(function(app) {

    app.provider("agentApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.searchAgentsForTransactionGroup = function(transactionGroupId, term) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/Agents/Search?q=" + term);
                    };

                    service.getAgentTransactionGroup = function() {
                        return complianceHubApiGateway.get("/Agents/TransactionGroup");
                    };

                    service.getCurrentAgent = function() {
                        return complianceHubApiGateway.get("/Agents/Current");
                    };

                    service.get = function(agentId) {
                        return complianceHubApiGateway.get("/Agents/" + agentId);
                    };

                    service.getAgentDisclosure = function(agentId, disclosureId) {
                        return complianceHubApiGateway.get("/Agents/" + agentId + "/Disclosure/" + disclosureId );
                    };

                    service.getAgentForUserId = function(userId) {
                        return complianceHubApiGateway.get("/Agents/User/" + userId);
                    };

                    service.addAgent = function(agent) {
                        return complianceHubApiGateway.post("/Agents", agent);
                    };

                    service.addArcAgent = function(agent) {
                        return complianceHubApiGateway.post("/Agents/" + agent.Id + "/Arc", agent);
                    };

                    service.updateDisclosure = function(disclosure, agentId) {
                        return complianceHubApiGateway.put("/Agents/" + agentId + "/Disclosure", disclosure);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line